import clsx from "clsx";
import React from "react";

export interface DashboarMenuItem {
  icon: React.ReactNode;
  onClick: () => void;
  label: string;
  selected: boolean;
  visible: boolean;
}

const DashboardMenu = ({ menuItems }: { menuItems: DashboarMenuItem[] }) => {
  return (
    <div className="p-4 flex flex-col text-sm">
      {menuItems
        .filter((item) => item.visible)
        .map((item, index) => (
          <div
            key={index}
            className={clsx(
              "flex cursor-pointer items-center py-2 px-2 mb-1 hover:bg-indigo-50 text-gray-700",
              "transition rounded font-medium last-of-type:mb-0",
              { "bg-indigo-50 text-indigo-700": item.selected }
            )}
            onClick={item.onClick}
          >
            <span
              className={clsx("text-gray-500 mr-3", {
                "text-indigo-500": item.selected,
              })}
            >
              {item.icon}
            </span>
            <span>{item.label}</span>
          </div>
        ))}
    </div>
  );
};

export default DashboardMenu;
